import React from "react";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import pages from "../../../../constants/pages";
import { validationSchema } from "./formDataObject";
import { ButtonFooter } from "../../../../components";
import { useAlert, useAxios } from "../../../../hooks";

export default function Form({
  formData,
  setFormData,
  editState,
  setEditState,
}) {
  const navigate = useNavigate();
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        axios({
          url: "/reverse-rc-bulk-process",
          method: "POST",
          data: {
            file_url: formData.fileURL,
            process_name: formData.fileName,
          },
        })
          .then(async (res) => {
            setSubmitting(false);
            if (res.status) {
              dispatch(
                alert({
                  message: "Bulk reverse process has been started",
                  type: "success",
                })
              );
              navigate(pages.reverseMappingList.route);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }}
    >
      {(formikProps) => (
        <React.Fragment>
          <FormDisplay formikProps={formikProps} />
          <ButtonFooter
            ID={formikProps.values.fileName}
            editState={true}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </React.Fragment>
      )}
    </Formik>
  );
}
